const LIMIT = 15;

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

async function fetchRecipients(page = 1) {
  try {
    console.log("Customer ID:", window.customerId);
    const customerId = window.customerId;
    // const customerId = 8070693290212;

    const url = `${window.BE_URL}/recipients/${customerId}?page=${page}&limit=${LIMIT}`;

    const tbody = document.getElementById("recipients-body");
    tbody.innerHTML =
      ' <td colspan=4> <div class="center"> <div class="loading-spinner"></div> </div></td>';

    const response = await fetch(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (!response.ok) throw new Error("Network response was not ok");
    const recipients = await response.json();
    const recipientsData = recipients?.data?.items;
    const paginationData = recipients?.data?.pagination;
    console.log({ recipientsData });
    if (!recipientsData || recipientsData <= 0) {
      const tbody = document.querySelector(".recipients-table-wrapper");
      tbody.innerHTML = "<p class='empty-para'> No data found </p>";
      return;
    }

    tbody.innerHTML = "";

    recipientsData?.forEach((recipient) => {
      const row = document.createElement("tr");
      row.className = "table-row";

      const nameCell = `<td class="table-cell recipient-name">${recipient.name}</td>`;
      const emailCell = `<td class="table-cell recipient-email">${recipient.email}</td>`;
      const dateCell = `<td class="table-cell created-date">${formatDate(
        recipient.createdAt
      )}</td>`;
      const giftsCell = `<td class="table-cell total-gifts">${recipient.noOfOrders}</td>`;

      row.innerHTML = nameCell + emailCell + dateCell + giftsCell;
      tbody.appendChild(row);
    });

    // paginaiton data 
    if(paginationData) {
      document.querySelector(".pagination-wrapper").classList.remove("hide");
      document.getElementById("totalPages").textContent = paginationData.totalPages;
      document.getElementById("currentPage").textContent = paginationData.currentPage;
      const prevBtn = document.getElementById("prevBtn");
      if (paginationData.currentPage === 1) {
        prevBtn.classList.add("disabled");
        prevBtn.style.pointerEvents = "none"; 
        prevBtn.style.opacity = "0.5";        
      } else {
        prevBtn.classList.remove("disabled");
        prevBtn.style.pointerEvents = "auto";
        prevBtn.style.opacity = "1";
      }

      const nextBtn = document.getElementById("nextBtn");
      if (paginationData.currentPage === paginationData.totalPages) {
        nextBtn.classList.add("disabled");
        nextBtn.style.pointerEvents = "none"; 
        nextBtn.style.opacity = "0.5";        
      } else {
        nextBtn.classList.remove("disabled");
        nextBtn.style.pointerEvents = "auto";
        nextBtn.style.opacity = "1";
      }

    }
  } catch (err) {
    console.log("error in fetching data", err);
  }
}

async function handlePagination(direction) {
  const currentPageElem = document.getElementById("currentPage");
  const totalPagesElem = document.getElementById("totalPages");

  let currentPage = parseInt(currentPageElem.textContent, 10);
  const totalPages = parseInt(totalPagesElem.textContent, 10);

  if (direction === "next" && currentPage < totalPages) {
    currentPage++;
  } else if (direction === "prev" && currentPage > 1) {
    currentPage--;
  }

  // Update page number in UI
  currentPageElem.textContent = currentPage;

  // Call your async function
  await fetchRecipients(currentPage);

  // Scroll to top of form (optional)
  // requestAnimationFrame(() => {
  //   const wrapper = document.querySelector('.multi-form-wrapper');
  //   if (wrapper) {
  //     wrapper.scrollTo({ top: 0, behavior: 'smooth' });
  //   }
  // });
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("in event listener");
  fetchRecipients();

  document.getElementById("nextBtn").addEventListener("click", () => {
    handlePagination("next");
  });

  document.getElementById("prevBtn").addEventListener("click", () => {

    handlePagination("prev");
  });
});
